import React from 'react'
import { Sidebar } from 'semantic-ui-react'
import { uniqueKey } from '../../../../global/common/keys'
import GenericIcon from '../../../../global/genericControls/GenericIcon'
import { g_cns } from '../../../../global/common/cns'

const _iconSize = 'large'
const _allowPopup = false

const MatchSidebar = (props) => {

  const {
    allowPopup,
    content,
    handleShowPopupContents,
    sidebarContent,
    styleAndClass,
    visible,
  } = props ?? {}

  const gi = (key, iconName, onClick, clickOptions, opts, corner) => <GenericIcon giProps={{ key, iconName, onClick, clickOptions, opts, corner }} />

  const popup = () => <span className={g_cns.item_settings}>
    {gi('item-icon-settings', 'sort numeric down', handleShowPopupContents, null, { circular: true, color: 'blue', size: _iconSize, inverted: true, sac: styleAndClass })}
  </span>

  const sidebar = () => <Sidebar.Pushable style={{ overflow: 'hidden' }}>
    <Sidebar
      animation={'overlay'}
      direction={'bottom'}
      onHide={() => handleShowPopupContents(false)}
      visible={visible}
      width='wide'
      className='ms-realtime'
      key={uniqueKey('ms', 'sb')}
    >
      {visible && sidebarContent}
    </Sidebar>
    <Sidebar.Pusher dimmed={visible} style={{ height: '100%' }}>
      {content}
      {_allowPopup && allowPopup && popup()}
    </Sidebar.Pusher>
  </Sidebar.Pushable>

  return sidebar()

}

export default MatchSidebar